import Consultation from './Consultation';

export default Consultation;